import {useState,useEffect} from 'react'
import userServices from '../app/admin/user/userServices';

function useUserList() {
    const [userList,setUserList] = useState(null);
    const getUserList = () =>{
        let _userList  =  JSON.parse(sessionStorage.getItem("userList"));
        if(_userList == null){
            console.log("get userList from use")
            userServices.getUserDDList().then(res=>{
                setUserList(res.data);
                sessionStorage.setItem("userList",JSON.stringify(res.data))
            })
        } else {
            setUserList(_userList);
        }
    }

    const getUserLabel = (id) => {
        try{
            let _user = userList.find(u => u.value === id)
            return _user.label;
        } catch(e){
            //console.log(type,id);
            return "";
        }
    }

    const getUserName = (id) => {
        try{
            let _user = userList.find(u => u.value === id)
            return _user.firstName+" "+_user.lastName;
        } catch(e){
            //console.log(type,id);
            return "";
        }
    }

    useEffect(()=>{
        getUserList();
    },[])
    return {userList,getUserLabel,getUserName};
}

export default useUserList